import { Injectable } from "@angular/core";
import { PagedResultGeneric } from "src/app/shared";
import { FinancialApiService } from "../financial-api.service";
import { PledgeLevelSearchDto } from "./dto/pledge-level-search.dto";
import { PledgeLevelDto } from "./dto/pledge-level.dto";

@Injectable({
  providedIn: 'root',
})
export class PledgeLevelService {
  public constructor(private _apiService: FinancialApiService) {}

  public searchPledgeLevels(seachParams: PledgeLevelSearchDto): Promise<PagedResultGeneric<PledgeLevelDto>> {
    return this._apiService.post('/financial/v2/pledgelevel/search', seachParams);
  }

  public getPledgeLevel(pledgeLevel: string) {
    return this._apiService.get(`/financial/v2/pledgelevel/${pledgeLevel}`);
  }

  public createPledgeLevel(pledgeLevel: PledgeLevelDto) {
    return this._apiService.post('/financial/v2/pledgelevel', pledgeLevel);
  }

  public updatePledgeLevel(pledgeLevel: PledgeLevelDto, currentPledgeLevel: string) {
    return this._apiService.put(`/financial/v2/pledgelevel/${currentPledgeLevel}`, pledgeLevel);
  }

  public deletePledgeLevel(pledgeLevel: string) {
    return this._apiService.delete(`/financial/v2/pledgelevel/${pledgeLevel}`);
  }
}
